
// Funcion que te convierte y devuelve el tipo de documento
export const extrac = (data) => {
    switch (data) {
        case 'Cédula':
            return 'CI';
        case 'Cédula Extranjera':
            return 'CI';
        case 'Pasaporte':
            return 'P';
        case 'Rif - J':
            return 'J';
        case 'Rif - V':
            return 'V';
        case 'Gobierno':
            return 'G';
        case 'Venezolano':
            return 'V';
        case 'Juridico':
            return 'J';
        default:
            break;

    }
}